import React, { useState } from "react";
import classnames from "classnames";
import Input from "../Input";
import { validate } from "../../../utilities/formValidators";
import CurrencyInput from "react-currency-input-field";

export interface FormInputProps {
    value?: string;
    id?: string;
    onChange?: (eventOrValue, optionalName?) => void; // eventOrValue because input and CurrencyInput are sharing the onChange function
    onEnter?: (event) => void;
    label?: string;
    type?: string;
    required?: boolean;
    className?: string;
    containerClassName?: string;
    step?: number;
    inputClassName?: string;
    placeholder?: string;
    errorClassName?: string;
    darkBg?: boolean;
    intlConfig?: {
        locale: string;
        currency: string;
    }
}

export default (props: FormInputProps) => {
    const { errorClassName, value = "", id, onChange, label, type = "text", onEnter, placeholder, required, className, step, inputClassName, containerClassName, darkBg, intlConfig, ...rest } = props;
    const [error, setError] = useState(null);

    const inputProps = {
        className: className,
        hasValue: value.length > 0,
        error,
        id,
        label,
        errorClassName,
        darkBg,
    };

    function handleEnter(event) {
        if (event.keyCode === 13 && typeof onEnter === "function") {
            onEnter(event.target.value);
        }
    }

    function handleBlur(event) {
        if (validate(event.target.value, type)) {
            setError("");
            onChange(event);
        } else {
            if (required) {
                setError(`${label} is required`);
            }
        }
    }

    return (
        <div className={containerClassName}>
            <Input
                {...inputProps} >
                {intlConfig ?
                    <CurrencyInput
                        {...rest}
                        intlConfig={intlConfig}
                        type={type}
                        name={id}
                        step={step}
                        value={value}
                        placeholder={placeholder}
                        onKeyUp={handleEnter}
                        onValueChange={onChange}
                        onBlur={handleBlur}
                        className={classnames("form-control", "px-3", "mb-2", inputClassName, { "has-label": label })}
                        autoComplete="off" />
                    :
                    <input
                        {...rest}
                        type={type}
                        name={id}
                        step={step}
                        value={value}
                        placeholder={placeholder}
                        onKeyUp={handleEnter}
                        onChange={onChange}
                        onBlur={handleBlur}
                        className={classnames("form-control", "px-3", "mb-2", inputClassName, { "has-label": label })}
                        autoComplete="off" />
                }
            </Input>
        </div>
    );
};